import IMessage from "../../shared/interfaces/message.interface";

export const MESSAGE: IMessage = {
    textMessage: "Perfecto!",
    style: "success",
    open: '',
    duration: 3000
}